module.exports = __webpack_public_path__ + "img/Glenn-Website-Photo.60e2af62.jpg";